module.exports = __webpack_public_path__ + "static/media/tag.7cdb499d.png";